export class InterviewerDetails {
  sTitleWillBeHeld: string;
  sTitleWillBeHeldInManner: string;
  sApplicationTakenBy: string;
  sApplicationTakenDate: Date;
  sEstateHeldMannerType: string;
  sEstimatedClosingDate: Date;
}
